import { render, staticRenderFns } from "./SubscribeToNewsletterInFooter.vue?vue&type=template&id=c927e3b4&scoped=true"
import script from "./SubscribeToNewsletterInFooter.vue?vue&type=script&lang=js"
export * from "./SubscribeToNewsletterInFooter.vue?vue&type=script&lang=js"
import style0 from "./SubscribeToNewsletterInFooter.vue?vue&type=style&index=0&id=c927e3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c927e3b4",
  null
  
)

export default component.exports